/*
 *
 * PaypalFields
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 29-Jan-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import '../ApmConfigurationModal.scss'
import formattedMessage, { messages } from '../languageModule'
import { findApmParamByName } from 'Utility/globalMethods'
import ApmSwitch from 'Components/ApmSwitch'
import { APM } from 'Schemas/apm'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import { useIntl } from 'react-intl'

const PaypalFields = ({ apm, paypalPayIn3, formik, loading }) => {
  const intl = useIntl()
  const paypalId = findApmParamByName(apm?.params, 'PAYPALID')?.value || ''
  const paypalEmail = findApmParamByName(apm?.params, 'PAYPALEMAIL')?.value || ''

  const { name: label, description, link } = APM.PAYPALPAGAIN3
  const paypalPayIn3Logo = paypalPayIn3?.feature?.logo

  const handleSwitchBnpl = (toggle) => {
    formik.setFieldValue('payIn3Status', toggle ? 'Enabled' : 'Disabled')
  }

  return (
    <>
      <div className='PaypalFields_info'>
        {!!paypalId && (
          <MerchantTableBadge label={`${intl.formatMessage(messages.paypalId)}: ${paypalId}`} status='lightGrey' />
        )}
        {!!paypalId && (
          <MerchantTableBadge
            label={`${intl.formatMessage(messages.paypalEmail)}: ${paypalEmail}`}
            status='lightGrey'
          />
        )}
      </div>
      {!!paypalPayIn3 && (
        <ApmSwitch
          subDescriptionLink={link}
          subDescriptionLinkLabel={formattedMessage.link}
          checked={formik.values.payIn3Status === 'Enabled'}
          disabled={formik.values.status === 'Disabled' || loading}
          onChange={handleSwitchBnpl}
          {...{ label, description, logo: paypalPayIn3Logo }}
        />
      )}
    </>
  )
}

PaypalFields.propTypes = {
  /** apm object */
  apm: PropTypes.object,
  /** paypal Pay In 3 APM */
  paypalPayIn3: PropTypes.object,
  /** formik object */
  formik: PropTypes.object,
  /** loading status */
  loading: PropTypes.bool
}

PaypalFields.defaultProps = {
  formik: {},
  loading: false
}

export default PaypalFields
